import ApiRouteProvider from '../route'
import axios from '@axios'

export default {
    subscribers(filters, sorting, page, perPage) {
        return axios.get(ApiRouteProvider.subscriber.list({
            filters,
            sort: sorting,
            page,
            perPage
        }));
    },

    get(id) {
        return axios.get(ApiRouteProvider.subscriber.get(id));
    },

    update(subscriber, subscription) {
        return axios.put(ApiRouteProvider.subscriber.update(subscriber.id), {
            title: subscriber.title,
            description: subscriber.description,
            comment: subscriber.comment,
            legalIdentities: subscriber.legalIdentities,
            domains: subscriber.domains,
            subscription: subscription
        });
    },

    create(subscriber, subscription) {
        return axios.post(ApiRouteProvider.subscriber.create(), {
            ...subscriber,
            subscription
        });
    },

    lookup(title, domain, legalIdentity) {
        let le = null;
        if (legalIdentity && legalIdentity.value && legalIdentity.type) {
            le = {
                value: legalIdentity.value,
                type: legalIdentity.type.id
            }
        }
        return axios.post(
            ApiRouteProvider.getBaseUrl() + '/subscribers/lookup',
            {
                title,
                domain,
                legalIdentity: le
            }
        )
    }
};
